export enum IconSizes {
  "1x" = "Extra Small",
  "2x" = "Small",
  "3x" = "Medium",
  "4x" = "Large",
  "5x" = "Extra Large",
  "6x" = "Extra Extra Large",
  "7x" = "Extra Extra Extra Large",
  "8x" = "Extra Extra Extra Extra Large",
  "9x" = "Bigger",
  "10x" = "Biggest"
}
export type IconSources = "fa" | "bx";
export type IconTypes = "solid" | "logo" | "brands" | "regular";
export const fontawesomeIconsSizes = {
  "1x": "2xs",
  "2x": "xs",
  "3x": "sm",
  "4x": "md",
  "5x": "lg",
  "6x": "xl",
  "7x": "2xl",
  "8x": "3xl",
  "9x": "4xl",
  "10x": "5xl"
};
export const boxiconsTypes = {
  solid: "f",
  regular: "r",
  logo: "l",
  brands: "l"
};
export const boxiconsSizes = {
  "1x": "xs",
  "2x": "sm",
  "3x": "base",
  "4x": "md",
  "5x": "lg",
  "6x": "xl",
  "7x": "2xl",
  "8x": "3xl",
  "9x": "4xl",
  "10x": "5xl"
};

/** Icons must never render below this size (see globals.css and Icon below). */
export const MIN_ICON_FONT_SIZE_PX = 25;

/**
 * Approximate em scale per size key, used only to compute a real minimum
 * font-size for the icon (`max(MIN_ICON_FONT_SIZE_PX, size * 1em)`), so
 * sizes bigger than the floor are preserved instead of being flattened to it.
 * Matches the real FontAwesome 6 sizing classes where one exists (2xs, xs,
 * sm, lg, xl, 2xl); "md"/"3xl" and up have no backing class in the vendored
 * subset, so they continue that same scale linearly.
 */
export const iconSizeEm: Record<keyof typeof IconSizes, number> = {
  "1x": 0.625,
  "2x": 0.75,
  "3x": 0.875,
  "4x": 1,
  "5x": 1.25,
  "6x": 1.5,
  "7x": 2,
  "8x": 2.5,
  "9x": 3,
  "10x": 3.5
};

interface IconProps {
  className?: string;
  name: string;
  size?: keyof typeof IconSizes;
}

export default IconProps;
